export default __webpack_public_path__ + "static/media/howtouse_basic_05_01_en.4d8d9499.png";